/* Invincible Garage: consent-gated diagnostics only. Standard ecommerce stays with Google & YouTube. */
(function () {
  'use strict';
  if (window.__igBehaviourInstalled) return;
  var configNode = document.getElementById('ig-behaviour-context');
  if (!configNode) return;
  var config;
  try { config = JSON.parse(configNode.textContent); } catch (_) { return; }
  if (config.measurement_id !== 'G-55ZWE59E1F') return;
  window.__igBehaviourInstalled = true;
  var events = ['ig_variant_change', 'ig_product_info_open', 'ig_consultation_click', 'ig_form_start', 'ig_form_error', 'ig_form_submit_attempt', 'ig_form_success', 'ig_cart_submit_attempt', 'ig_checkout_click', 'ig_technical_error', 'ig_page_performance'];
  var forms = new WeakSet();
  var errors = new WeakSet();
  var seen = new Set();
  var configured = false;
  var lastVariant = String(config.variant_id || '');
  var eventCount = 0;
  var performanceSent = false;

  function permitted() {
    if (window.location.hostname !== 'store.invinciblegarage.ca') return false;
    if (['product', 'collection', 'page', 'index', 'cart'].indexOf(config.page_type) === -1) return false;
    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    try { return !!privacy && typeof privacy.analyticsProcessingAllowed === 'function' && privacy.analyticsProcessingAllowed() === true; }
    catch (_) { return false; }
  }
  function safeCode(value) {
    return typeof value === 'string' && /^[A-Za-z0-9][A-Za-z0-9_. -]{0,79}$/.test(value) ? value : undefined;
  }
  function variant(id) {
    var all = Array.isArray(config.variants) ? config.variants : [];
    for (var i = 0; i < all.length; i += 1) if (String(all[i].id) === String(id)) return all[i];
    return null;
  }
  function safeLocation() {
    // No queries, fragments, search terms, account routes or submitted data.
    var path = window.location.pathname;
    return /^\/(?:[a-z]{2}\/)?(?:(?:products|collections|pages)\/[a-z0-9][a-z0-9-]*|cart)?\/?$/.test(path) ? window.location.origin + path : window.location.origin + '/';
  }
  function emitter() {
    if (!configured) {
      if (typeof window.gtag !== 'function') {
        window.dataLayer = window.dataLayer || [];
        window.gtag = function () { window.dataLayer.push(arguments); };
        window.gtag('js', new Date());
        var script = document.createElement('script');
        script.async = true;
        script.src = 'https://www.googletagmanager.com/gtag/js?id=G-55ZWE59E1F';
        document.head.appendChild(script);
      }
      window.gtag('consent', 'update', {analytics_storage: 'granted'});
      window.gtag('config', config.measurement_id, {
        send_page_view: false, allow_google_signals: false, allow_ad_personalization_signals: false,
        page_location: safeLocation(), page_referrer: '', page_title: 'Invincible Garage',
      });
      configured = true;
    }
    return window.gtag;
  }
  function emit(name, input) {
    if (!permitted() || events.indexOf(name) === -1 || eventCount >= 60) return false;
    input = input || {};
    var p = {send_to: config.measurement_id, tracking_version: '20261018', page_type: config.page_type,
      page_location: safeLocation(), page_referrer: '', page_title: 'Invincible Garage',
      allow_google_signals: false, allow_ad_personalization_signals: false};
    if (safeCode(config.product_handle)) p.product_handle = config.product_handle;
    if (/^\d+$/.test(String(config.product_id || ''))) p.product_id = String(config.product_id);
    var selected = variant(input.variant_id) || variant(lastVariant);
    if (selected) { p.variant_id = String(selected.id); if (safeCode(selected.sku)) p.item_id = selected.sku; }
    var allowed = {
      form_type: ['cabinet_help', 'cabinet_consultation', 'consultation'],
      info_type: ['shipping', 'dimensions', 'specifications', 'description', 'warranty', 'other'],
      error_type: ['validation', 'server_validation', 'script_error', 'resource_error', 'unhandled_rejection'],
      load_bucket: ['under_1s', '1_to_3s', '3_to_5s', 'over_5s'],
    };
    Object.keys(allowed).forEach(function (key) { if (allowed[key].indexOf(input[key]) !== -1) p[key] = input[key]; });
    try { if (!permitted()) return false; emitter()('event', name, p); eventCount += 1; return true; }
    catch (_) { return false; }
  }
  function closest(target, selector) { return target && typeof target.closest === 'function' ? target.closest(selector) : null; }
  function typeOfForm(form) {
    var type = form && form.getAttribute('data-ig-lead-form');
    return ['cabinet_help', 'cabinet_consultation', 'consultation'].indexOf(type) !== -1 ? type : 'consultation';
  }
  function once(key, name, props) { if (!permitted() || seen.has(key)) return; if (emit(name, props)) seen.add(key); }

  // Empire emits a non-bubbling variant-change on its light-DOM variant-selection element.
  document.addEventListener('variant-change', function (event) {
    if (!permitted()) return;
    var id = event.detail && event.detail.variant && String(event.detail.variant.id);
    if (variant(id) && id !== lastVariant) { lastVariant = id; emit('ig_variant_change', {variant_id: id}); }
  }, true);
  document.addEventListener('visitorConsentCollected', function () {
    if (!configured || typeof window.gtag !== 'function') return;
    // Reflect Shopify's analytics policy only; do not grant/change advertising consent.
    window.gtag('consent', 'update', {analytics_storage: permitted() ? 'granted' : 'denied'});
  }, false);
  document.addEventListener('change', function (event) {
    var form = closest(event.target, 'form[data-product-form]');
    if (!form || !permitted()) return;
    window.setTimeout(function () {
      if (!permitted()) return;
      var input = form.querySelector('[name="id"]');
      var id = input && String(input.value);
      if (variant(id) && id !== lastVariant) { lastVariant = id; emit('ig_variant_change', {variant_id: id}); }
    }, 0);
  }, false);
  document.addEventListener('focusin', function (event) {
    var form = closest(event.target, 'form[data-ig-lead-form]');
    if (form && !forms.has(form) && emit('ig_form_start', {form_type: typeOfForm(form)})) forms.add(form);
  }, false);
  document.addEventListener('invalid', function (event) {
    var form = closest(event.target, 'form[data-ig-lead-form]');
    if (form && !errors.has(form) && emit('ig_form_error', {form_type: typeOfForm(form), error_type: 'validation'})) errors.add(form);
  }, true);
  document.addEventListener('submit', function (event) {
    var form = closest(event.target, 'form[data-ig-lead-form]');
    if (form) { emit('ig_form_submit_attempt', {form_type: typeOfForm(form)}); errors.delete(form); }
    else if (closest(event.target, 'form[data-product-form]')) emit('ig_cart_submit_attempt', {});
  }, true);
  document.addEventListener('click', function (event) {
    var target = event.target;
    var link = closest(target, 'a[href]');
    if (link) {
      var href = link.getAttribute('href') || '';
      if (/^(?:\/[a-z]{2})?\/pages\/consultation(?:[?#]|$)/.test(href) || /^#ig-priority-help-\d+$/.test(href)) emit('ig_consultation_click', {});
      if (/^(?:\/[a-z]{2})?\/checkout(?:[?#]|$)/.test(href)) emit('ig_checkout_click', {});
    }
    var checkout = closest(target, '[name="checkout"]');
    if (checkout) emit('ig_checkout_click', {});
    var summary = closest(target, 'summary');
    if (summary && summary.parentElement && !summary.parentElement.open) {
      // Only static product-info headings are classified; text is never transmitted.
      if (!closest(summary, '[data-product-wrapper]')) return;
      var label = String(summary.textContent || '').toLowerCase();
      var info = /shipping|delivery|livraison/.test(label) ? 'shipping' : /dimension|size|taille/.test(label) ? 'dimensions' : /specification|technical|technique/.test(label) ? 'specifications' : /warranty|garantie/.test(label) ? 'warranty' : /description/.test(label) ? 'description' : 'other';
      once('info:' + info, 'ig_product_info_open', {info_type: info});
    }
  }, false);
  document.addEventListener('ig:contact-success', function (event) {
    var detail = event.detail || {};
    if (detail.analytics_allowed_at_submit !== true || typeof detail.event_id !== 'string' || !/^[A-Za-z0-9-]{1,100}$/.test(detail.event_id)) return;
    if (!permitted()) return;
    var key = 'ig_ga_success_' + detail.event_id;
    try {
      if (window.sessionStorage.getItem(key)) return;
      window.sessionStorage.setItem(key, '1');
      if (window.sessionStorage.getItem(key) !== '1') return;
    } catch (_) { return; }
    once(key, 'ig_form_success', {form_type: detail.lead_type});
  }, false);
  window.addEventListener('error', function (event) { once('error:' + (event.target && event.target !== window ? 'resource' : 'script'), 'ig_technical_error', {error_type: event.target && event.target !== window ? 'resource_error' : 'script_error'}); }, true);
  window.addEventListener('unhandledrejection', function () { once('error:promise', 'ig_technical_error', {error_type: 'unhandled_rejection'}); }, false);
  function performanceEvent() {
    if (performanceSent || !permitted()) return;
    var perf = window.performance;
    var nav = perf && typeof perf.getEntriesByType === 'function' && perf.getEntriesByType('navigation')[0];
    if (!nav || nav.loadEventEnd <= 0) return;
    var elapsed = nav.loadEventEnd - (nav.startTime || 0);
    if (emit('ig_page_performance', {load_bucket: elapsed < 1000 ? 'under_1s' : elapsed < 3000 ? '1_to_3s' : elapsed < 5000 ? '3_to_5s' : 'over_5s'})) performanceSent = true;
  }
  window.addEventListener('load', function () { window.setTimeout(performanceEvent, 0); }, false);
  if (document.readyState === 'complete') window.setTimeout(performanceEvent, 0);
  // Ask Shopify to expose its policy-aware consent API; never infer consent from a cookie.
  if (window.Shopify && !window.Shopify.customerPrivacy && typeof window.Shopify.loadFeatures === 'function') {
    window.Shopify.loadFeatures([{name: 'consent-tracking-api', version: '0.1'}], function () {});
  }
  if (window.__IG_BEHAVIOUR_TEST__) window.__igBehaviourTest = {emit: emit, permitted: permitted};
}());
